import Vue from 'vue';

export default Vue.component('ed-chip-group', { 
  name: 'ed-chip-group',
});